/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Spanish (es) string table · dr-ronlan.html
   English is the source of truth in the HTML; this file supplies the
   Spanish counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-es.js.
   Proper names, institution names, journal titles, patent numbers and
   molecular names stay in their original form.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.es = window.TD_I18N.es || {};
  Object.assign(window.TD_I18N.es, {

    /* ── Meta ── */
    'ronlan.docTitle': 'Dr. K. Alvin Ronlán · Investigación y trayectoria — Transderma',

    /* ── Page header ── */
    'ronlan.headLabel': 'Investigación y trayectoria',
    'ronlan.headTitle': 'Dr. K. Alvin <em>Ronlán</em>',
    'ronlan.headSub': 'Fundador, Director de I+D. Tres décadas de química de fenoles, ahora aplicadas a la piel.',

    /* ── Quick facts ── */
    'ronlan.facts.label': 'Datos rápidos',
    'ronlan.facts.bornK': 'Nacimiento',
    'ronlan.facts.bornV': '15 de agosto de 1942, Copenhague, Dinamarca',
    'ronlan.facts.domK': 'Residencia',
    'ronlan.facts.domV': 'Florida, EE. UU.',
    'ronlan.facts.langK': 'Idiomas',
    'ronlan.facts.langV': 'Danés, sueco, inglés, alemán',
    'ronlan.facts.roleK': 'Cargo actual',
    'ronlan.facts.roleV': 'Director de I+D, Alron Chemical Co AB · Cofundador, ProBios Laboratories, Inc.',

    /* ── Education ── */
    'ronlan.eduLabel': 'Formación',
    'ronlan.eduTitle': 'Cuatro titulaciones,<br><em>tres países.</em>',
    'ronlan.edu1h': 'Licenciatura · matemáticas, física, química',
    'ronlan.edu1p': 'Universidad de Copenhague e Instituto Danés de Tecnología.',
    'ronlan.edu2h': 'Máster · física y química',
    'ronlan.edu2p': 'Universidad de Uppsala, Suecia.',
    'ronlan.edu3h': 'Doctorado (Ph.D.)',
    'ronlan.edu3p': 'Real Instituto de Tecnología, Estocolmo, Suecia.',
    'ronlan.edu4h': 'Doctor en Ciencias',
    'ronlan.edu4p': 'Universidad de Lund, Suecia.',

    /* ── Career ── */
    'ronlan.carLabel': 'Trayectoria',
    'ronlan.carTitle': 'De la academia<br><em>al laboratorio.</em>',
    'ronlan.carIntro': 'Seis décadas de docencia, investigación y química aplicada. Lo más destacado a continuación.',
    'ronlan.car1h': 'Profesor ayudante, Universidad de Uppsala',
    'ronlan.car1p': 'Primer puesto docente durante sus estudios de máster.',
    'ronlan.car2h': 'Investigador asociado, Real Instituto de Tecnología, Estocolmo',
    'ronlan.car2p': 'Sus años de doctorado en Estocolmo.',
    'ronlan.car3h': 'Profesor adjunto, Universidad de Lund',
    'ronlan.car3p': 'Inicia el trabajo sobre química de fenoles y oxidación anódica que más tarde sustenta la formulación de Transderma.',
    'ronlan.car4h': 'Profesor asistente, Universidad de Lund',
    'ronlan.car5h': 'Catedrático, Universidad de Lund',
    'ronlan.car5p': 'Promovido a catedrático de Química Bioorgánica, dirige el grupo de investigación sobre antioxidantes fenólicos y radicales catiónicos.',
    'ronlan.car6h': 'Director del Departamento de Química, Universidad de Lund',
    'ronlan.car6p': 'Dirige el departamento de química de la Universidad de Lund.',
    'ronlan.car7h': 'Director de I+D, Alron Chemical Co AB',
    'ronlan.car7p': 'En curso · funda el laboratorio en 1977 para química y física de superficies y catálisis de combustión. Ese mismo año funda también Alron Japan, Inc. en Tokio.',
    'ronlan.car8h': 'Profesor visitante, Universidad de California, Santa Cruz',
    'ronlan.car8p': 'Aplica la inteligencia artificial temprana a problemas químicos y bioquímicos.',
    'ronlan.car9h': 'Cofundador y Director de I+D, ProBios Laboratories, Inc.',
    'ronlan.car9p': 'Junto a Graziella Gallelli Ronlan. Investigación y desarrollo con sede en Florida.',
    'ronlan.car10h': 'Consultor, Erco Pharmaceuticals',
    'ronlan.car10p': 'Coautor de patentes sobre medios de contraste y fármacos hipotensores.',
    'ronlan.car11h': 'Expedición a África Oriental',
    'ronlan.car11p': 'Organizó y dirigió una expedición de cuatro meses por Kenia, Tanzania y Uganda para recolectar plantas medicinales.',

    /* ── Publications ── */
    'ronlan.pubLabel': 'Publicaciones seleccionadas',
    'ronlan.pubTitle': 'Fenoles, antioxidantes,<br><em>radicales catiónicos.</em>',
    'ronlan.pubIntro': 'Diez artículos revisados por pares que muestran la química que sustenta las formulaciones de Transderma. La bibliografía completa de 31 artículos está disponible en la descarga del CV.',
    'ronlan.pub1': '<em>Phenol Dehydrogenation. Intramolecular Oxidative Coupling of Dihydropiceatannol.</em> Acta Chem. Scand., 23, 249 (1969). Con Holger Erdtman.',
    'ronlan.pub2': '<em>The Structure of Mezerein, A Major Toxic Principle of Daphne Mezerum L.</em> Tetrahedron Letters, 1970, 4261. Con Börje Wickberg.',
    'ronlan.pub3': '<em>Coupling of Phenols via an Anodically Generated Ion.</em> Chem. Commun., 1971, 1643.',
    'ronlan.pub4': '<em>Anodic Oxidation of Phenolic Compounds. Part II. Products and Mechanisms of the Anodic Oxidation of Hindered Phenols.</em> J. Chem. Soc., C, 1971, 3241. Con V.D. Parker.',
    'ronlan.pub5': '<em>Kinetics and Mechanisms of the Reaction of Organic Cation Radicals and Dications.</em> J. Amer. Chem. Soc., 96, 5108 (1974). Con V.D. Parker y U. Svanholm.',
    'ronlan.pub6': '<em>Anodic Oxidation of Phenolic Compounds. Part V. Anodic Methoxylation of Phenols.</em> J. Chem. Soc. Perk I, 1978, 696.',
    'ronlan.pub7': '<em>Anodic Coupling of Simple Aryl Ethers.</em> Tetrahedron Letters, 1972, 2272.',
    'ronlan.pub8': '<em>The Direct Observation of Intermediates During the Oxidative Cyclization of Phenol Ethers.</em> Acta Chem. Scand., 1974.',
    'ronlan.pub9': '<em>Electrosynthesis of Medium and Large Sized Rings by Oxidative Cyclization.</em> J. Org. Chem., 39, 1014 (1974).',
    'ronlan.pub10': '<em>The Relative Ease of Oxidation of Phenols and Phenol Ethers.</em> Acta Chem. Scand., 1976.',
    'ronlan.pub11': '<em>Systematic Derivation of Chemical Procedures for Transforming Surplus Hazardous Chemicals to Useful Products.</em> Journal of Hazardous Materials, 1984.',
    'ronlan.pubFull': 'La bibliografía completa de 31 artículos revisados por pares está disponible en la descarga del CV.',

    /* ── Patents ── */
    'ronlan.patLabel': 'Patentes',
    'ronlan.patTitle': 'Siete patentes,<br><em>una central para la piel.</em>',
    'ronlan.patFeatBadge': 'La base de Transderma',
    'ronlan.patFeatTitle': 'US Pat. 20080118449 · Cosmetic Formulations of Piceatannol and Retinoids and Methods of Use Thereof',
    'ronlan.patFeatBody': 'Esta patente es la base química de Transderma. El piceatannol es el principio activo de Serum R; los retinoides (palmitato de retinilo) son el principio activo de Serum A. La patente describe cómo actúan estas dos moléculas juntas sobre la piel.',
    'ronlan.patFeatLinkA': 'Comprar Serum R',
    'ronlan.patFeatLinkB': 'Comprar Serum A',
    'ronlan.pat1': 'US Pat. 6,500,465 · Composición desinfectante y esporicida · descontaminación de edificios.',
    'ronlan.pat2': 'US Pat. 5,540,767 · Composición y método de equilibrado de neumáticos.',
    'ronlan.pat3': 'US Pat. 5,431,726 · Composición de equilibrado.',
    'ronlan.pat4': 'US Pat. 4,867,792 · Composición de equilibrado de neumáticos.',
    'ronlan.pat5': 'European Patent EP1196299 · Composiciones de equilibrado de neumáticos.',
    'ronlan.pat6': 'European Patent EP0281252 · Composición y método de equilibrado de neumáticos.',

    /* ── Shop CTA ── */
    'ronlan.ctaLabel': 'La química aplicada',
    'ronlan.ctaTitle': 'La patente está<br><em>dentro del frasco.</em>',
    'ronlan.ctaBody': 'Dos de los cinco sérums de Transderma provienen directamente de la patente cosmética del Dr. Ronlán. Empieza por ahí, o prueba el sistema completo en el Discovery Kit.',
    'ronlan.ctaBtnR': 'Serum R · Piceatannol',
    'ronlan.ctaBtnA': 'Serum A · Retinoide',
    'ronlan.ctaBtnKit': 'Discovery Kit · los cinco',

    /* ── PDF download footer ── */
    'ronlan.dlNote': '¿Prefieres el documento original?',
    'ronlan.dlLink': 'Descargar el CV completo (PDF) →'

  });
})();
